/**
 * Canonical routes for the SICA public site.
 * Source of truth: docs/pendings/ADR-005-plan-refactorizacion-web.md §2.
 */
export const ROUTES = {
  home: '/',
  producto: {
    index: '/producto',
    jurisdicciones: '/producto/jurisdicciones',
    metodo: '/producto/metodo',
    mcp: '/producto/mcp',
  },
  audiencias: {
    docentes: '/audiencias/docentes',
    directivos: '/audiencias/directivos',
    especialistas: '/audiencias/especialistas',
    desarrolladores: '/audiencias/desarrolladores',
  },
  glosario: '/glosario',
  sobre: '/sobre',
  contacto: '/contacto',
  legal: '/legal',
} as const;
